<template>

    <transition name="cookie-banner">
        <div v-if="show" class="cookie-banner">
            <p class="cookie-banner-text">{{ $t('messages.cookie_banner_text') }}</p>
            <div class="cookie-banner-actions">
                <v-button size="sm" theme="white" @click.native="customize">{{ $t('labels.customize') }}</v-button>
                <v-button size="sm" theme="white" @click.native="rejectAll">{{ $t('labels.reject_all') }}</v-button>
                <v-button size="sm" @click.native="acceptAll">{{ $t('labels.accept_all') }}</v-button>
            </div>
        </div>
    </transition>

</template>

<style scoped lang="scss">

    .cookie-banner-enter-active,
    .cookie-banner-leave-active {
        transition: opacity .2s ease, transform .2s ease;
    }
    .cookie-banner-enter {
        opacity: 0;
        transform: translateY(20px);
    }
    .cookie-banner-leave-to {
        opacity: 0;
        transform: translateY(20px);
    }

    .cookie-banner {
        align-items: flex-start;
        background: $color-white;
        border: 1px solid $color-rule;
        border-radius: 5px;
        bottom: 20px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.12);
        box-sizing: border-box;
        display: flex;
        gap: 15px;
        justify-content: space-between;
        left: 20px;
        max-width: 680px;
        padding: 20px;
        position: fixed;
        width: calc(100% - 40px);
        z-index: 10000;
        @media (max-width: map-get($grid-breakpoints, 'sm')) {
            border-left: none;
            border-radius: 0;
            border-right: none;
            bottom: 0;
            flex-direction: column;
            left: 0;
            max-width: 100%;
            width: 100%;
            .cookie-banner-actions {
                width: 100%;
                .btn {
                    flex: 1;
                }
            }
        }
    }

    .cookie-banner-text {
        @include font-medium(13px);
        color: $color-text;
        flex: 1;
        line-height: 1.4em;
        margin: 0;
    }

    .cookie-banner-actions {
        align-items: center;
        display: flex;
        flex-shrink: 0;
        gap: 8px;
    }

</style>

<script>

import ConsentUtil from '@utils/ConsentUtil';

export default {

    computed: {

        show() {
            return this.$store.getters.showCookieBanner;
        },

    },

    methods: {

        acceptAll() {
            ConsentUtil.acceptAll();
        },

        rejectAll() {
            ConsentUtil.rejectAll();
        },

        customize() {
            this.$store.commit('setModal', 'cookie-preferences');
        },

    },

}

</script>
